import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EMPTY, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ResetPassword } from 'src/app/shared/interface/cit-interface';
import { CITService } from 'src/app/services/cit.service';
import { Helper } from 'src/app/shared/utils/helper';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  form: FormGroup;
  isLoading:boolean=true;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private toast:ToastrService,
    private emsService:CITService,
    private route:ActivatedRoute,
  ) { }

  ngOnInit() {
    const myDate = new Date('Mon Feb 15 2021 08:00:00 GMT+0800');
    const currentDate = new Date();
    if (myDate.getTime() > currentDate.getTime()) {
      return this.router.navigate(['./reset-pwd']);
    }
    this.createForm();
    const code = this.route.snapshot.queryParams.code;
    const email = this.route.snapshot.queryParams.email;
    this.bindData({email:email,code:code});
    this.verifyCode();
  }



  verifyCode(){
    this.isLoading= true;
    const {email,code} = this.form.getRawValue();
    const data = {email:email,code:code};
    // console.log(data);

    this.emsService.verifyCode(data)
    .pipe(
      tap(()=>this.isLoading=false),
      tap((res)=>{
        if (res.result==false) {
          // this.toast.error("Invalid Link");
          this.router.navigate(['./error-404', "Invalid Link"]);
        }
      }),
      catchError(()=>(
        // this.toast.error("Invalid Link"),
        this.isLoading=false,
        this.router.navigate(['./error-404', "Invalid Link"])
        ))
    )
    .subscribe();
  }

  private bindData(data){
    return this.form.patchValue(data);
  }

  createForm() {
    this.form = this.fb.group(
      {
        code: [null, [Validators.required]],
        email: [null, [Validators.required, Validators.email]],
        password: [null, [Validators.required, Validators.minLength(8), Validators.maxLength(32)]],
        confirmPassword: [null]
      },
      {
        validators: this.MustMatch('password', 'confirmPassword'),
      }
    )
  }

  MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  onSubmit() {
    const {code, email, password} = this.form.getRawValue();
    const data:ResetPassword = {
      code: code, email:email,password:password
    }
    if (this.form.invalid) {
      return this.form.markAllAsTouched();
    }

    this.emsService.resetPassword(data).pipe(
      tap((res)=>{
        if (res) {
          return(
            this.toast.success("Password has been successfully reset",null, {timeOut:6000}),
            this.router.navigate(['./login']));
        }
      }),
      catchError((err)=>{
        return of(EMPTY);
      })
    ).subscribe();
  }

  hasSmallLetter():boolean{
    const rgx =/^(?=.*[a-z])/.test(this.form.get("password").value);
    return !rgx;
  }

  hasNumber():boolean{
    const rgx =/^(?=.*[0-9])/.test(this.form.get("password").value);
    return !rgx;
  }

}
